export function editorReady(ev) {
	const { user } = this.props;

	ev.editor.on(
		"fileUploadRequest",
		function(evt) {
			const token = user.token;
			const AUTH_HEADER = process.env.REACT_APP_SITE_KEY + ":Bearer " + token;

			const fileLoader = evt.data.fileLoader;
			const formData = new FormData();
			const xhr = fileLoader.xhr;

			xhr.open("POST", fileLoader.uploadUrl, true);
			formData.append("name", fileLoader.fileName);
			formData.append("imgData", fileLoader.data);

			xhr.setRequestHeader("AUTHORIZATION", AUTH_HEADER);
			xhr.send(formData);

			// Prevented the default behavior.
			evt.stop();
		},
		null,
		null,
		4
	);

	ev.editor.on("fileUploadResponse", function(evt) {
		// Prevent the default response handler
		evt.stop();

		// Get XHR and response.
		const data = evt.data;
		const xhr = data.fileLoader.xhr;
		const response = JSON.parse(xhr.responseText);

		// Error
		if (response.uploaded === 0) {
			data.message = response.error;
			evt.cancel();
		}
		// Success
		else {
			data.url = response.url;
			data.fileLoader.fileName = response.fileName;
		}
	});
}



// WEBPACK FOOTER //
// ./src/utils/editor.js